import { defineComponent, createElementBlock, openBlock, renderSlot, useSlots, computed, ref, useTemplateRef, watch, createBlock, unref, normalizeClass, withCtx, createCommentVNode, createVNode, createSlots, normalizeProps, guardReactiveProps, createElementVNode, Fragment, mergeProps, withModifiers, toDisplayString, Transition, renderList } from "vue";
import { WCard, WCardTitle } from "../../../WCard/index.js";
import { loaderAnimationData } from "../../../../assets/lottie/loader.js";
import { checkingAnimationData } from "../../../../assets/lottie/checking.js";
import { favoriteAnimationData } from "../../../../assets/lottie/favorite.js";
import { WCasinoCardCounter } from "./WCasinoCardCounter/index.js";
import { _sfc_main as _sfc_main$4 } from "../../../WCurtain/index.js";
import { _sfc_main as _sfc_main$5, WBadge } from "../../../WBadge/WBadge/index.js";
import "../../../WIcon/WIconStd/index.js";
import { iconToProp } from "../../../WIcon/index.js";
import { WButton } from "../../../WButton/index.js";
import { WLottie } from "../../../WLottie/index.js";
import { WToggleButton } from "../../../WToggleButton/index.js";
import { _export_sfc } from "../../../WAccordion/index.js";
import { WSkeleton } from "../../../WSkeleton/index.js";
import "../../../WIcon/WIconExt/index.js";
import "vue-router";
import './index.css';const DATA_TEST = {
  TOGGLE: "w-casino-card-toggle",
  HOVER_CONTAINER: "w-casino-card-hover-container",
  SELECTED_CONTAINER: "w-casino-card-selected-container",
  BLOCKED_CONTAINER: "w-casino-card-blocked-container",
  PLAY_BUTTON: "w-casino-card-play-button",
  DEMO_BUTTON: "w-casino-card-demo-button"
};
const _hoisted_1$2 = { class: "w-casino-card-header" };
const _sfc_main$3 = /* @__PURE__ */ defineComponent({
  __name: "WCasinoCardHeader",
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$2, [
        renderSlot(_ctx.$slots, "default", {}, void 0, true)
      ]);
    };
  }
});
const WCasinoCardHeader = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["__scopeId", "data-v-26d84f1a"]]);
const _hoisted_1$1 = {
  key: 0,
  class: "w-casino-card__additional-link"
};
const _hoisted_2$1 = { class: "w-casino-card__image-placeholder" };
const _hoisted_3$1 = ["data-t"];
const _hoisted_4$1 = {
  key: 1,
  class: "w-casino-card__select-hover-text"
};
const _hoisted_5 = ["data-t"];
const _hoisted_6 = ["data-t"];
const _hoisted_7 = {
  key: 0,
  class: "w-casino-card__blocked-title"
};
const _hoisted_8 = {
  key: 0,
  class: "w-casino-card__card-top"
};
const _hoisted_9 = { class: "w-casino-card__badges" };
const _hoisted_10 = {
  key: 0,
  class: "w-casino-card__right"
};
const _hoisted_11 = {
  key: 0,
  class: "w-casino-card__additional-link"
};
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  __name: "WCasinoCard",
  props: {
    type: { default: "default" },
    label: {},
    extraLabel: { default: void 0 },
    imageUrl: { default: void 0 },
    badges: { default: void 0 },
    toggleButtonProps: { default: void 0 },
    toggleButton: { type: Boolean, default: void 0 },
    playButtonProps: { default: void 0 },
    demoButtonProps: { default: void 0 },
    hovered: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
    selectHoverText: { default: void 0 },
    selected: { type: Boolean, default: void 0 },
    blockingReason: { default: void 0 },
    blocked: { type: Boolean, default: false },
    counter: { default: void 0 },
    additionalBadge: { default: void 0 }
  },
  emits: ["play", "demo", "clickLink"],
  setup(__props, { emit: __emit }) {
    const slots = useSlots();
    const props = __props;
    const emit = __emit;
    const isDefaultType = computed(() => props.type === "default");
    const isSelectType = computed(() => props.type === "select");
    const badgesProps = computed(() => {
      const defaultProps = { size: "md" };
      return (props.badges ?? []).slice(0, 2).map(
        (badge) => typeof badge === "string" ? { label: badge, ...defaultProps } : { ...defaultProps, ...badge }
      );
    });
    function onPlay(event) {
      emit("play", event);
    }
    function onDemo(event) {
      emit("demo", event);
    }
    const cardState = computed(() => {
      const { loading, blocked, selected, hovered } = props;
      const isLoading = !blocked && loading;
      const isSelected = !loading && !blocked && selected || showSelected.value;
      const isHovered = !loading && !blocked && hovered;
      const showBadges = !loading && !selected && !blocked;
      const isShowLink = !isLoading && slots.link;
      return {
        isLoading,
        isSelected,
        isHovered,
        showBadges,
        isShowLink
      };
    });
    const showSelected = ref(false);
    const checkingRef = useTemplateRef("checkingRef");
    function onCheckingComplete() {
      var _a;
      if (((_a = checkingRef.value) == null ? void 0 : _a.direction) === -1) {
        showSelected.value = false;
      }
    }
    watch(
      () => props.selected,
      (selected) => {
        var _a, _b, _c;
        if (selected) {
          (_a = checkingRef.value) == null ? void 0 : _a.play();
          showSelected.value = true;
        } else {
          (_b = checkingRef.value) == null ? void 0 : _b.setDirection(-1);
          (_c = checkingRef.value) == null ? void 0 : _c.play();
        }
      },
      { immediate: true }
    );
    const favoriteRef = useTemplateRef("favoriteRef");
    watch(
      () => {
        var _a;
        return (_a = props.toggleButtonProps) == null ? void 0 : _a.modelValue;
      },
      (modelValue) => {
        if (modelValue === void 0) return;
        playFavoriteAnimation(modelValue);
      }
    );
    function onFavoriteMounted() {
      var _a;
      if (favoriteRef.value) {
        favoriteRef.value.goToAndStop(
          ((_a = props.toggleButtonProps) == null ? void 0 : _a.modelValue) ? 90 : 0,
          true
        );
      }
    }
    function onFavoriteToggle(toggle) {
      var _a;
      if (((_a = props.toggleButtonProps) == null ? void 0 : _a.modelValue) !== void 0) return;
      playFavoriteAnimation(toggle);
    }
    function playFavoriteAnimation(isToggle) {
      var _a, _b;
      (_a = favoriteRef.value) == null ? void 0 : _a.setDirection(isToggle ? 1 : -1);
      (_b = favoriteRef.value) == null ? void 0 : _b.play();
    }
    const classes = computed(() => ({
      "--selected": cardState.value.isSelected,
      "--hovered": cardState.value.isHovered,
      "--loading": cardState.value.isLoading,
      "--blocked": props.blocked,
      "--hide-badges": !cardState.value.showBadges
    }));
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(WCard), {
        class: normalizeClass(["w-casino-card", classes.value]),
        hovered: cardState.value.isHovered
      }, {
        header: withCtx(() => [
          createVNode(WCasinoCardHeader, { class: "w-casino-card__header" }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "header", {}, void 0, true),
              cardState.value.isShowLink ? (openBlock(), createElementBlock("div", _hoisted_1$1, [
                renderSlot(_ctx.$slots, "link", {}, void 0, true)
              ])) : createCommentVNode("", true),
              createVNode(unref(_sfc_main$4), {
                class: "w-casino-card__image",
                src: _ctx.imageUrl,
                alt: _ctx.label,
                "object-fit": "cover"
              }, {
                placeholder: withCtx(() => [
                  createElementVNode("div", _hoisted_2$1, [
                    createVNode(unref(_sfc_main$5), {
                      class: "w-casino-card__image-placeholder-icon",
                      name: "outline-images-3"
                    })
                  ])
                ]),
                _: 1
              }, 8, ["src", "alt"]),
              _ctx.hovered && !cardState.value.isSelected ? (openBlock(), createElementBlock("div", {
                key: 1,
                class: "w-casino-card__hover-container",
                "data-t": unref(DATA_TEST).HOVER_CONTAINER
              }, [
                isDefaultType.value ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                  createVNode(unref(WButton), mergeProps({
                    class: "w-casino-card__play w-casino-card__button",
                    "left-icon": unref(iconToProp)("filled-play"),
                    size: "lg",
                    set: "accent",
                    variant: "primary",
                    compact: ""
                  }, _ctx.playButtonProps, {
                    "data-t": unref(DATA_TEST).PLAY_BUTTON,
                    onClick: withModifiers(onPlay, ["prevent"])
                  }), null, 16, ["left-icon", "data-t"]),
                  _ctx.demoButtonProps ? (openBlock(), createBlock(unref(WButton), mergeProps({
                    key: 0,
                    size: "sm",
                    set: "static-black",
                    variant: "tertiary",
                    text: "demo"
                  }, _ctx.demoButtonProps, {
                    class: "w-casino-card__button",
                    "data-t": unref(DATA_TEST).DEMO_BUTTON,
                    onClick: withModifiers(onDemo, ["prevent"])
                  }), null, 16, ["data-t"])) : createCommentVNode("", true)
                ], 64)) : isSelectType.value && _ctx.selectHoverText ? (openBlock(), createElementBlock("div", _hoisted_4$1, toDisplayString(_ctx.selectHoverText), 1)) : createCommentVNode("", true)
              ], 8, _hoisted_3$1)) : createCommentVNode("", true),
              createVNode(Transition, { name: "w-casino-card-selected" }, {
                default: withCtx(() => [
                  cardState.value.isSelected && _ctx.type === "select" ? (openBlock(), createElementBlock("div", {
                    key: 0,
                    class: "w-casino-card__selected",
                    "data-t": unref(DATA_TEST).SELECTED_CONTAINER
                  }, [
                    createVNode(unref(WLottie), {
                      ref_key: "checkingRef",
                      ref: checkingRef,
                      class: "w-casino-card__selected-lottie",
                      "animation-data": unref(checkingAnimationData),
                      onComplete: onCheckingComplete
                    }, null, 8, ["animation-data"])
                  ], 8, _hoisted_5)) : createCommentVNode("", true)
                ]),
                _: 1
              }),
              _ctx.blocked ? (openBlock(), createElementBlock("div", {
                key: 2,
                class: "w-casino-card__blocked",
                "data-t": unref(DATA_TEST).BLOCKED_CONTAINER
              }, [
                _ctx.blockingReason ? (openBlock(), createElementBlock("h4", _hoisted_7, toDisplayString(_ctx.blockingReason), 1)) : createCommentVNode("", true),
                renderSlot(_ctx.$slots, "blocked-link", {}, void 0, true)
              ], 8, _hoisted_6)) : createCommentVNode("", true)
            ]),
            _: 3
          }),
          isDefaultType.value ? (openBlock(), createElementBlock("div", _hoisted_8, [
            createElementVNode("div", _hoisted_9, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(badgesProps.value, (badgeProps, i) => {
                return openBlock(), createBlock(unref(WBadge), mergeProps({
                  key: i,
                  class: "w-casino-card__badges-item"
                }, { ref_for: true }, badgeProps), null, 16);
              }), 128))
            ]),
            !_ctx.blocked && (_ctx.toggleButton || _ctx.loading || _ctx.additionalBadge) ? (openBlock(), createElementBlock("div", _hoisted_10, [
              _ctx.loading ? (openBlock(), createBlock(unref(WLottie), {
                key: 0,
                "animation-data": unref(loaderAnimationData),
                loop: "",
                "is-current-color": "",
                class: "w-casino-card__loader"
              }, null, 8, ["animation-data"])) : _ctx.toggleButton ? (openBlock(), createBlock(unref(WToggleButton), mergeProps({
                key: 1,
                "data-t": unref(DATA_TEST).TOGGLE,
                class: "w-casino-card__button w-casino-card__button-toggle",
                "active-icon": "filled-heart",
                "inactive-icon": "outline-heart"
              }, _ctx.toggleButtonProps, {
                onClick: _cache[0] || (_cache[0] = withModifiers(() => {
                }, ["prevent", "stop"])),
                onToggle: onFavoriteToggle
              }), {
                default: withCtx(() => {
                  var _a;
                  return [
                    createVNode(unref(WLottie), {
                      ref_key: "favoriteRef",
                      ref: favoriteRef,
                      class: "w-casino-card__button-toggle-lottie",
                      "animation-data": unref(favoriteAnimationData),
                      direction: ((_a = _ctx.toggleButtonProps) == null ? void 0 : _a.modelValue) ? 1 : -1,
                      autoplay: false,
                      onMounted: onFavoriteMounted
                    }, null, 8, ["animation-data", "direction"])
                  ];
                }),
                _: 1
              }, 16, ["data-t"])) : createCommentVNode("", true),
              _ctx.additionalBadge ? (openBlock(), createBlock(unref(WBadge), {
                key: 2,
                class: "w-casino-card__additional-badge",
                variant: "label",
                set: "static-black",
                size: "md",
                label: _ctx.additionalBadge
              }, null, 8, ["label"])) : createCommentVNode("", true)
            ])) : createCommentVNode("", true)
          ])) : createCommentVNode("", true)
        ]),
        footer: withCtx(() => [
          createVNode(unref(WCardTitle), {
            title: _ctx.label,
            subtitle: _ctx.extraLabel
          }, createSlots({ _: 2 }, [
            _ctx.counter ? {
              name: "rightContent",
              fn: withCtx(() => [
                createVNode(unref(WCasinoCardCounter), normalizeProps(guardReactiveProps(_ctx.counter)), null, 16)
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["title", "subtitle"])
        ]),
        additional: withCtx(() => [
          cardState.value.isShowLink ? (openBlock(), createElementBlock("div", _hoisted_11, [
            renderSlot(_ctx.$slots, "link", {}, void 0, true)
          ])) : createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["class", "hovered"]);
    };
  }
});
const WCasinoCard = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["__scopeId", "data-v-29fc6c80"]]);
const _hoisted_1 = { class: "w-casino-card-title-skeleton" };
const _hoisted_2 = {
  key: 0,
  class: "w-casino-card-title-skeleton__left-content"
};
const _hoisted_3 = { class: "w-casino-card-title-skeleton__content" };
const _hoisted_4 = { class: "w-casino-card-title-skeleton__right-content" };
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "WCardTitleSceleton",
  props: {
    set: { default: "black" },
    animated: { type: Boolean, default: true }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        _ctx.$slots["leftContent"] ? (openBlock(), createElementBlock("div", _hoisted_2, [
          renderSlot(_ctx.$slots, "leftContent", {}, void 0, true)
        ])) : createCommentVNode("", true),
        createElementVNode("div", _hoisted_3, [
          createVNode(unref(WSkeleton), {
            class: "w-casino-card-title-skeleton__title",
            set: _ctx.set,
            animated: _ctx.animated
          }, null, 8, ["set", "animated"]),
          createVNode(unref(WSkeleton), {
            class: "w-casino-card-title-skeleton__subtitle",
            set: _ctx.set,
            animated: _ctx.animated
          }, null, 8, ["set", "animated"])
        ]),
        createElementVNode("div", _hoisted_4, [
          createVNode(unref(WSkeleton), {
            class: "w-casino-card-title-skeleton__title",
            set: _ctx.set,
            animated: _ctx.animated
          }, null, 8, ["set", "animated"]),
          createVNode(unref(WSkeleton), {
            class: "w-casino-card-title-skeleton__subtitle",
            set: _ctx.set,
            animated: _ctx.animated
          }, null, 8, ["set", "animated"])
        ])
      ]);
    };
  }
});
const WCardTitleSceleton = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["__scopeId", "data-v-40433ac3"]]);
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "WCasinoCardSkeleton",
  props: {
    set: { default: "black" },
    animated: { type: Boolean, default: true }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(WCard), { class: "w-casino-card-skeleton" }, {
        header: withCtx(() => [
          createVNode(WCasinoCardHeader, { class: "w-casino-card__header" }, {
            default: withCtx(() => [
              createVNode(unref(WSkeleton), {
                class: "w-casino-card__header-skeleton",
                set: _ctx.set,
                animated: _ctx.animated
              }, null, 8, ["set", "animated"])
            ]),
            _: 1
          })
        ]),
        footer: withCtx(() => [
          createVNode(WCardTitleSceleton, {
            set: _ctx.set,
            animated: _ctx.animated
          }, null, 8, ["set", "animated"])
        ]),
        _: 1
      });
    };
  }
});
const WCasinoCardSkeleton = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-4a653348"]]);
export {
  WCasinoCard,
  WCasinoCardSkeleton
};
